import VueBaseController from '../vue_base'

export class IndexController extends VueBaseController {
  static values = { orderId: String, orderNumber: String, reportUrl: String }
  static get COMPONENT() { return () => import('@/vue/pages/users/anchor_shot_tasks/index.vue') }
}

export class NewController extends VueBaseController {
  static values = { orderId: String, orderNumber: String }
  static get COMPONENT() { return () => import('@/vue/pages/users/anchor_shot_tasks/new.vue') }
}
